import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import useInitializeApp from 'hooks/useInitializeApp';
import { toggleAppOverlay, setLoggedOutFromTimeout, resetUISlice } from 'reducers/ui/uiSlice';
import { resetCurrentUserSlice } from 'reducers/currentUser/currentUserSlice';
import { resetPaymentFormSlice } from 'reducers/paymentForm/paymentFormSlice';
import { resetSettingsSlice } from 'reducers/settingsSlice';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import Spinner from 'components/Spinner';

const getLoginURLParams = () => {
  const params = new URLSearchParams(window.location.search);
  const surname = params.get('surname');

  return { surname };
};

const handleSSOLogin = async (dispatch, initializeApp, navigate) => {
  try {
    dispatch(setLoggedOutFromTimeout(false));
    dispatch(toggleAppOverlay(false));
    dispatch(resetUISlice());
    dispatch(resetCurrentUserSlice());
    dispatch(resetPaymentFormSlice());
    dispatch(resetSettingsSlice());

    const { surname } = getLoginURLParams();

    if (surname) {
      const loginCredentials = {
         lastName: surname,
      };
      await initializeApp(loginCredentials, true);
    } else {
      throw new Error("Missing one or more required parameters to login with SSO");
    }
  } catch (error) {
    console.error(error.message);
    navigate(`${ROUTES_SELF_SERVICE.SSOLOGINFAIL}?reason=${encodeURIComponent(error.message)}`);
  }
};

export default function SSOLoginSuccess() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isInitializing, initializeApp] = useInitializeApp();
  const selectedBooking = useSelector((state) => state.ui.selectedBooking);
  const { componentConfig } = useSelector((state) => state.ui);
  const [isSSOLoginComplete, setSSOLoginComplete] = useState(false);
  const hasRunSSOLogin = useRef(false);

  useEffect(() => {
    if (hasRunSSOLogin.current) return;
    hasRunSSOLogin.current = true;

    const initializeSSOLogin = async () => {
      await handleSSOLogin(dispatch, initializeApp, navigate);
      setSSOLoginComplete(true);
    };

    initializeSSOLogin();
  }, [dispatch, initializeApp, navigate]);

  useEffect(() => {
    if (isSSOLoginComplete && !isInitializing) {
      const multiBookingRedirect = 
        componentConfig.multiBookingEnabled ? 
          `${ROUTES_SELF_SERVICE.OVERVIEW}` : 
          `${ROUTES_SELF_SERVICE.BOOKINGS}/${selectedBooking.id || selectedBooking.reference}`;
      navigate(multiBookingRedirect);
    }
  }, [isSSOLoginComplete, isInitializing, navigate, selectedBooking, componentConfig.multiBookingEnabled]);

  return (
    <div className="flex flex-col justify-center h-[100vh] gap-4 text-center">
      <Spinner />
      <p>Loading ...{'\n'}This can take up to a minute.</p>
    </div>
  );
}
